import {get, writable, derived } from 'svelte/store';

const isGeoData = writable();

const isOpenData = writable(false);

const isModel = writable(false);

const isAuth = writable(false);

const validateForm = writable(false);

const user = writable({});

export {
    isGeoData,
    isOpenData,
    isModel,
    isAuth,
    validateForm,
    user
};